module.exports = __webpack_public_path__ + "img/list.456e58d1.svg";